module.exports = __webpack_public_path__ + "static/media/thirdScreen@3x.491333c8.png";